export class Email {
    emailSeqNum: number;
    emailAddress: string;
    oldEmailAddress: string;
    emailIndex: number;
    constructor(emailAddress: string) {
        this.emailAddress = emailAddress;
    }
}
